import { ProfileState } from './profile.types';

export const preloadedProfileState: ProfileState = {
  isLoading: false,
  item: null,
  avatarFile: null,
  currentStatusesCount: 0,
};
